import React from "react";

const CloseUpdateIcon = ({ className = "", ...props }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M17.7929 5.29306C18.1834 4.90256 18.8164 4.90255 19.207 5.29306C19.5973 5.68359 19.5974 6.31664 19.207 6.70713L13.914 12.0001L19.207 17.2931L19.2753 17.3692C19.5955 17.762 19.573 18.3411 19.207 18.7071C18.8409 19.0732 18.2618 19.0957 17.8691 18.7755L17.7929 18.7071L12.4999 13.4142L7.20696 18.7071C6.81647 19.0976 6.18343 19.0975 5.79289 18.7071C5.40237 18.3166 5.40237 17.6836 5.79289 17.2931L11.0859 12.0001L5.79289 6.70713C5.40237 6.3166 5.40237 5.68359 5.79289 5.29306C6.18342 4.90256 6.81644 4.90255 7.20696 5.29306L12.4999 10.586L17.7929 5.29306Z"
        fill="#FF5050"
      />
    </svg>
  );
};

export default CloseUpdateIcon; 